import React, { useContext } from 'react';
import { StyleSheet, TextStyle, ViewStyle, View } from 'react-native';
import { EmphasizedSubText, Text, ThemeContext, TranslationsContext } from '..';

interface EmphasizedTextProps {
  emphasizedTextStyles?: TextStyle;
  emphasizedText: string;
  textStyles?: TextStyle;
  titleStyles?: TextStyle;
}

interface ImportantNoticeOwnProps {
  children?: any;
  containerStyles?: ViewStyle;
}

export type ImportantNoticeProps = ImportantNoticeOwnProps & EmphasizedTextProps;

/*eslint-disable react-native/no-unused-styles*/
const getStyles = (theme: Theme) =>
  StyleSheet.create({
    container: {
      backgroundColor: theme.colors.background,
      paddingHorizontal: 20,
      paddingVertical: 40,
    },
    emphasizedText: {
      color: theme.colors.primary.normal,
      fontWeight: theme.font.weight.bold,
    },
    text: {
      lineHeight: 20,
      textAlign: 'left',
    },
    title: {
      color: theme.colors.primary.normal,
      fontSize: 18,
      fontWeight: theme.font.weight.bold,
      paddingBottom: 16,
      textAlign: 'left',
    },
  });

export const ImportantNotice = ({
  children,
  containerStyles,
  emphasizedTextStyles,
  emphasizedText,
  textStyles,
  titleStyles,
}: ImportantNoticeProps): React.JSX.Element=> {
  const translations = useContext(TranslationsContext);
  const theme = useContext(ThemeContext);
  const styles = getStyles(theme);

  return (
    <View style={[styles.container, containerStyles]}>
      {!!translations.components.importantNotice && (
        <Text style={[styles.title, titleStyles]}>{translations.components.importantNotice}</Text>
      )}
      <EmphasizedSubText
        emphStyle={[styles.emphasizedText, emphasizedTextStyles]}
        style={[styles.text, textStyles]}
        text={emphasizedText}
      />
      {children}
    </View>
  );
};
